import { IsString, IsNotEmpty, Matches } from 'class-validator';

export class CreateGroupDTO {
  @IsNotEmpty()
  @IsString()
  public groupType_id? : string;

  public group_id! : string | null;

  @IsNotEmpty({ message: 'Name Required' })
  @IsString()
  @Matches(/^[A-Za-z0-9_ ]{0,20}$/,
    { message: 'Wrong name format' })
  public name! : string;

  @IsNotEmpty({ message: 'Code Required' })
  @IsString()
  @Matches(/^[A-Za-z0-9_]{0,20}$/,
    { message: 'Wrong code format' })
  public code! : string;
}
